export function generateUniqueInt() {
    const timestamp = Date.now();
    const random = Math.floor(Math.random() * 1000);
    return timestamp % 10000000000 + random;
}

const currencyFormatter = new Intl.NumberFormat('fa-IR', {
    style: 'currency',
    currency: 'IRR',
    minimumFractionDigits: 0
});

export function formatCurrency(value) {
    return currencyFormatter.format(value)
}

export function formatNumber(value, options = {}) {
    const opts = {
        currency: 'IRR',
        minimumFractionDigits: 0, ...options
    };
    return new Intl.NumberFormat('fa-IR', opts).format(value)
}

export function currencyReadable(value, decimals = 2) {
    if (value === 0) return '0';

    const units = ['', 'میلیون', 'میلیارد', 'تریلیارد']; // Million, Billion, Trillion (skip 'K')
    const k = 1000;

    // Determine the appropriate unit
    const i = Math.floor(Math.log10(value) / 3); // Group digits into thousands

    // Skip 'K' by adjusting the index
    const adjustedIndex = i < 1 ? 0 : i - 1; // If i is 1 (thousands), treat it as 0 (no unit)

    // Ensure the adjusted index is within the units array bounds
    const unitIndex = Math.min(adjustedIndex, units.length - 1);

    // Calculate the divisor based on the unit
    const divisor = unitIndex === 0 ? 1 : Math.pow(k, unitIndex + 1);

    // Format the value
    const formattedValue = parseFloat((value / divisor).toFixed(decimals));

    // Add comma separator for values less than 1 million
    if (unitIndex === 0) {
        return formatNumber(value)
        return `${value.toLocaleString()}`;
    }

    return `${formatNumber(formattedValue)} ${units[unitIndex]}`;
}


export function formatSize(value, unit = 'bytes', decimals = 2) {
    const units = ['bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'];
    const k = 1024;

    // Convert the input value to bytes first
    let bytes;
    switch (unit.toLowerCase()) {
        case 'bytes':
            bytes = value;
            break;
        case 'kb':
            bytes = value * Math.pow(k, 1);
            break;
        case 'mb':
            bytes = value * Math.pow(k, 2);
            break;
        case 'gb':
            bytes = value * Math.pow(k, 3);
            break;
        case 'tb':
            bytes = value * Math.pow(k, 4);
            break;
        case 'pb':
            bytes = value * Math.pow(k, 5);
            break;
        case 'eb':
            bytes = value * Math.pow(k, 6);
            break;
        case 'zb':
            bytes = value * Math.pow(k, 7);
            break;
        case 'yb':
            bytes = value * Math.pow(k, 8);
            break;
        default:
            throw new Error('Invalid unit. Supported units are: bytes, KB, MB, GB, TB, PB, EB, ZB, YB');
    }

    if (bytes === 0) return '0 bytes';

    // Determine the appropriate unit
    const i = Math.floor(Math.log(bytes) / Math.log(k));
    const formattedValue = parseFloat(bytes / Math.pow(k, i)).toFixed(decimals);

    return `${formattedValue} ${units[i]}`;
}

export function formatDate(dateString) {
    return new Date(dateString).toLocaleDateString('en-US', {
        year: 'numeric',
        month: 'short',
        day: 'numeric'
    })
}